/**
 * @generated SignedSource<<c02c54386039dcf50c9d1c1bfdac415a>>
 * @relayHash 23128c7f975773e696f5dc815605552c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 8bd2c50d7613ef27c0c7f5d9ff9b9f059c7e8c6add7f7091c71b35680d18da7b

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type JiraProjectListRightPanelState = "CLOSED" | "OPEN" | "%future added value";
export type src_growthRecommendationsInProjectList_RecommendationsInProjectListQuery$variables = {
  cloudId: string;
  isAnonymous: boolean;
};
export type src_growthRecommendationsInProjectList_RecommendationsInProjectListQuery$data = {
  readonly jira?: {
    readonly canCreateProject: boolean | null | undefined;
    readonly sidebarExperimentTemplates: {
      readonly totalCount: number | null | undefined;
    } | null | undefined;
    readonly userPreferences: {
      readonly projectListRightPanelState: JiraProjectListRightPanelState | null | undefined;
    } | null | undefined;
    readonly " $fragmentSpreads": FragmentRefs<"ui_growthRecommendationsInProjectList_RecommendationsInProjectList">;
  } | null | undefined;
};
export type src_growthRecommendationsInProjectList_RecommendationsInProjectListQuery = {
  response: src_growthRecommendationsInProjectList_RecommendationsInProjectListQuery$data;
  variables: src_growthRecommendationsInProjectList_RecommendationsInProjectListQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "isAnonymous"
  }
],
v1 = {
  "kind": "Variable",
  "name": "cloudId",
  "variableName": "cloudId"
},
v2 = [
  (v1/*: any*/)
],
v3 = {
  "kind": "ScalarField",
  "name": "projectListRightPanelState"
},
v4 = [
  (v1/*: any*/),
  {
    "kind": "Literal",
    "name": "experimentKey",
    "value": "sidebarExperiment"
  }
],
v5 = {
  "alias": "sidebarExperimentTemplates",
  "args": (v4/*: any*/),
  "concreteType": "JiraProjectListViewTemplateConnection",
  "kind": "LinkedField",
  "name": "projectListViewTemplates",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "totalCount"
    }
  ]
},
v6 = {
  "alias": "canCreateProject",
  "args": [
    (v1/*: any*/),
    {
      "kind": "Literal",
      "name": "type",
      "value": "CREATE_PROJECT"
    }
  ],
  "kind": "ScalarField",
  "name": "canPerform"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "src_growthRecommendationsInProjectList_RecommendationsInProjectListQuery",
    "selections": [
      {
        "condition": "isAnonymous",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "concreteType": "JiraQuery",
            "kind": "LinkedField",
            "name": "jira",
            "plural": false,
            "selections": [
              {
                "args": (v2/*: any*/),
                "concreteType": "JiraUserPreferences",
                "kind": "LinkedField",
                "name": "userPreferences",
                "plural": false,
                "selections": [
                  (v3/*: any*/)
                ]
              },
              (v5/*: any*/),
              (v6/*: any*/),
              {
                "kind": "FragmentSpread",
                "name": "ui_growthRecommendationsInProjectList_RecommendationsInProjectList"
              }
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "src_growthRecommendationsInProjectList_RecommendationsInProjectListQuery",
    "selections": [
      {
        "condition": "isAnonymous",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "concreteType": "JiraQuery",
            "kind": "LinkedField",
            "name": "jira",
            "plural": false,
            "selections": [
              {
                "args": (v2/*: any*/),
                "concreteType": "JiraUserPreferences",
                "kind": "LinkedField",
                "name": "userPreferences",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  {
                    "kind": "ClientExtension",
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "__id"
                      }
                    ]
                  }
                ]
              },
              (v5/*: any*/),
              (v6/*: any*/),
              {
                "args": (v4/*: any*/),
                "concreteType": "JiraProjectListViewTemplateConnection",
                "kind": "LinkedField",
                "name": "projectListViewTemplates",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "JiraProjectListViewTemplateItem",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "key"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "templateType"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "productKey"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "isProductLicensed"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "title"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "shortDescription"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "isPremiumOnly"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "canCreate"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "recommendationSessionId"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "iconUrl"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "iconDarkUrl"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "description"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "previewUrl"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "previewDarkUrl"
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "8bd2c50d7613ef27c0c7f5d9ff9b9f059c7e8c6add7f7091c71b35680d18da7b",
    "metadata": {},
    "name": "src_growthRecommendationsInProjectList_RecommendationsInProjectListQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "1d5593aeca46929a56364eb8ee925a79";

import { PreloadableQueryRegistry } from 'relay-runtime';
PreloadableQueryRegistry.set(node.params.id, node);

export default node;
